import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import * as action from '../../state/search/action'
import * as selector from '../../state/search/selector'
import SalesOrderSearch from './SalesOrderSearch'


const mapStateToProps = state => {
    return {
        tableData: selector.selectRetainerTable(state),
        type: 'retainer',
    }
}

const mapDispatchToProps = {
    initialTableQuery: action.initialTableQueryRetainer,
    changeFilter: action.changeFilterRetainer,
    toggleSort: action.toggleSortRetainer,
    toggleMultiSort: action.toggleMultiSortRetainer,
    gotoPage: action.gotoPageRetainer,
    initialColumnsVisibility: action.initialTableSettingsRetainer,
    toggleColumnVisibility: action.toggleColumnVisibilityRetainer,
    navigateToSalesOrder: (salesOrderId) => {
        return push('/sales-order/edit/' + salesOrderId)
    },
}


export default connect(mapStateToProps, mapDispatchToProps)(SalesOrderSearch)



// WEBPACK FOOTER //
// ./src/modules/sales-order/component/search/RetainerSalesOrderSearchContainer.js